export const initialFilterSharedSafari = {
  park_id: 0,
  month_id: 0,
  type: 0,
  estimate_price_min: 0,
  estimate_price_max: 0,
  no_of_safari_min: 0,
  no_of_safari_max: 0,
  share_safari_agenda_id: 0,
  stay_category_id: 0,
  host_type: 0,
  custom_sort_by: 0,
};

export const initialFilterSharedSafariPark = {
  month_id: 0,
  type: 0,
  estimate_price_min: 0,
  estimate_price_max: 0,
  no_of_safari_min: 0,
  no_of_safari_max: 0,
  share_safari_agenda_id: 0,
  stay_category_id: 0,
  host_type: 0,
  custom_sort_by: 0,
};

export const initialSummary = {
  total: 0,
  page: 1,
  pageSize: 12,
  total_page: 1,
};

export const initialOrganizeSafari = {
  slug: '',
  share_safari_title: '',
  park_id: '',
  start_date: '',
  end_date: '',
  no_of_safari: 1,
  // step-2
  share_safari_agenda_id: '',
  stay_category_id: '',
  estimate_price_min: '',
  estimate_price_max: '',
  total_seat: '',
  share_seat: '',
  // step-3
  shared_safari_image: null,
  safari_plan: '',
  safariPhotoUrl: ''
}

export const initialOrganizeSafariErrors = {
  slug: '',
  share_safari_title: '',
  park_id: '',
  start_date: '',
  end_date: '',
  no_of_safari: '',
  // step-2
  share_safari_agenda_id: '',
  stay_category_id: '',
  estimate_price_min: '',
  estimate_price_max: '',
  total_seat: '',
  share_seat: '',
  // step-3
  shared_safari_image: '',
  safari_plan: '',
  safariPhotoUrl: ''
}